export default {"src":"https://fishbrain.com/_next/static/media/arkansas.137621d3.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};